import type { FC, PropsWithChildren } from 'react';
import type { ViewProps } from 'react-native';
import { View } from 'react-native';

export const Expand: FC<PropsWithChildren & ViewProps> = ({
  children,
  style,
  ...props
}) => (
  <View style={[{ flex: 1 }, style]} {...props}>
    {children}
  </View>
);
